import AllOFPsCorrelatesOfQualityDownload from './AllOFPsCorrelatesOfQualityDownload';

export default AllOFPsCorrelatesOfQualityDownload;
